<template>
  <div class="container relative">
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      <ApartmentCard
        v-for="item in apartmentsData"
        :key="item.listing_id"
        :apartment="{
          listing_id: Number(item.listing_id),
          title: item.title,
          cover_photo: item.cover_photo,
          capacity: item.capacity,
          rooms: item.rooms,
          area_sqm: item.area_sqm,
          view_type: item.view_type,
          floor: item.floor,
        }"
        :gallery="item.gallery"
        :catalog-price="item.price"
        :locale="locale"
        :whatsapp-number="whatsappNumber"
        :telegram-link="telegramLink"
        :guest-facts="guestFactsMap[Number(item.listing_id)] ?? null"
      />
    </div>
  </div>
</template>

<script setup lang="ts">

const { locale } = useI18n();
const config = useRuntimeConfig();
const whatsappNumber = config.public.whatsappNumber as string;
const telegramLink = (config.public.telegramLink as string) || "";

const { data: apartments } = await useAsyncData(
  `apartments_list-${locale.value}`,
  async () => {
    const collection = ("apartments_" + locale.value) as "apartments_en";
    const content = await queryCollection(collection).all();
    return content;
  },
);

const { data: fromPrices } = await useFetch<Record<number, number>>(
  '/api/apartments/from-prices',
  { default: () => ({}) },
);

type GuestFacts = { capacity: number; threshold: number; extraGuestUsd?: number };
const { data: guestFactsMap } = await useFetch<Record<number, GuestFacts>>(
  '/api/apartments/facts',
  { default: () => ({}) },
);

const apartmentsData = computed(() =>
  (apartments.value || [])
    // Hide apartments not publicly visible. `guestFactsMap` is keyed by the
    // server's active && listed set, so its keys are the catalog allowlist —
    // a content card without a facts entry is a hidden listing.
    .filter((item) => guestFactsMap.value[Number(item.listing_id)])
    .map((item) => ({
    listing_id: item.listing_id || "",
    title: item.title || "",
    price: fromPrices.value[Number(item.listing_id)] ?? null,
    capacity: item.capacity,
    rooms: item.rooms,
    area_sqm: item.area_sqm,
    view_type: item.view_type,
    floor: item.floor,
    cover_photo: item.cover_photo?.[0] || {
      url: "/images/placeholder-image.jpg",
      alt: "placeholder-image",
    },
    gallery: Array.isArray(item.photo_gallery) ? item.photo_gallery : [],
  }))
);
</script>
